<template>
  <b-card title="Get Browser Information">
    <b-form-group
      label="Enter browser string from log"
    >
      <b-form-textarea 
        v-model="browserstring"
      />
    </b-form-group>
    <div v-show="device_type!=''">
      <b-form-group>
        <b-form-input v-model="device_type" type="text" readonly />
      </b-form-group>
      <b-form-group>
        <b-form-input v-model="platform" type="text" readonly />
      </b-form-group>
      <b-form-group>
        <b-form-input v-model="browser" type="text" readonly />
      </b-form-group>      
    </div>
    <b-button
      @click.prevent="getinformation"
    >
      Get information
    </b-button>
  </b-card>
</template>
<script>
import axios from 'axios'
import { config } from '../../config';
const api_token = config.api_token;

export default {
  name: 'GetBrowser',
  mounted() {
  },
  data: function() {
    return {
      browserstring: '',
      device_type: '',
      platform: '',
      browser: '',
    }

  },
  methods: {
    getinformation() {
      const data = {
        b: this.browserstring,
      }
      axios.defaults.headers.common['Authorization'] = 'Bearer:'+api_token;
      return new Promise((resolve) => {
        axios.post(
          'http://api.eventerex.com/gdq/gdq_getbrowser.php',
          JSON.stringify(data), {
            headers: {
              "Accept": "application/json",
              "Content-type": "application/json",
            }
          }
        )
        .then((resp) => {
          this.device_type = resp.data.device_type;
          this.platform = resp.data.platform;
          this.browser = resp.data.browser+' '+resp.data.version;
          resolve(resp);
        })
      });           
    },
  }  
}
</script>
<style scoped>

</style>